import { DeveloperTypes } from 'dash-common';

import { RoutesPath } from 'flow-components/routes/routes';

import type { ISidebarItems } from './Container.interfaces';

export const getSidebarItemsList = ({
  developerType,
}: {
  developerType?: DeveloperTypes;
}): ISidebarItems => {
  const items: ISidebarItems = [
    {
      label: 'dashboard',
      icon: 'chart',
      path: RoutesPath.Dashboard,
    },
    {
      label: 'properties',
      icon: 'home',
      path: RoutesPath.Properties,
    },
  ];

  if (developerType === DeveloperTypes.ORGANIZATION_USER) {
    items.push({
      label: 'organization',
      icon: 'suitcase',
      path: RoutesPath.Organization,
    });
  }

  if (developerType === DeveloperTypes.SALE_TEAM_USER) {
    items.push({
      label: 'externalSales',
      icon: 'chart',
      path: RoutesPath.ExternalSales,
    });
  }

  return items;
};
